export const spinnerReducer = (state = {}, { blocking, key }) => {
  if (typeof blocking === 'boolean' && key) {
    return { ...state, [key]: blocking };
  } else {
    return state;
  }
};

export default spinnerReducer;
